module.exports = __webpack_public_path__ + "media/images/google-play-logo-05cf004815236dd84ae651ee9dea5d76.png";